import React from 'react'
import { AddressSelector, SectionHeader } from '@base'
import { strings } from '@constants'
import { StepWrapper } from '../../style'


const DispatchLocation = ({ addresses, addNewAddressHandler, addDispatchLocation, dispatchLocation }) => {
	return (
		<StepWrapper>
			<SectionHeader>{strings('dispatch_location')}</SectionHeader>
			<AddressSelector
				labels={{
					changeButtonLabel: strings('change', 'location'),
					addNewButtonLabel: strings(['add', 'new', 'location']),
					orSelectLabel: strings('label_select_from_existing_locations'),
				}}
				selectedAddress={dispatchLocation}
				savedAddresses={addresses}
				onChange={addDispatchLocation}
				addNewAddressHandler={addNewAddressHandler}
			/>
		</StepWrapper>
	)
}

export default DispatchLocation
